import {
  handleWithErrorMessage,
  handleWithGlobalMessage
} from "@/services/utils";
import api from "@/services/modules/users/languagesAndSkills";
import {
  SET_IS_FETCHING_USER_LANGUAGES,
  SET_IS_FETCHING_USER_SKILLS,
  SET_CURRENT_USER_LANGUAGES,
  SET_CURRENT_USER_SKILLS,
  SET_IS_FETCHING_ALL_LANGUAGES,
  SET_IS_FETCHING_ALL_SKILLS,
  SET_IS_FETCHING_LANGUAGE_LEVELS,
  SET_IS_FETCHING_SKILL_LEVELS,
  SET_ALL_LANGUAGES,
  SET_ALL_SKILLS,
  SET_LANGUAGE_LEVELS,
  SET_SKILL_LEVELS
} from "@/store/modules/users/languagesAndSkills/mutations";
import { filter, map } from "lodash";

export const FETCH_USER_LANGUAGES = "FETCH_USER_LANGUAGES";
export const FETCH_USER_SKILLS = "FETCH_USER_SKILLS";
export const FETCH_ALL_LANGUAGES = "FETCH_ALL_LANGUAGES";
export const FETCH_ALL_SKILLS = "FETCH_ALL_SKILLS";
export const FETCH_LANGUAGE_LEVELS = "FETCH_LANGUAGE_LEVELS";
export const FETCH_SKILL_LEVELS = "FETCH_SKILL_LEVELS";
export const REMOVE_USER_LANGUAGE = "REMOVE_USER_LANGUAGE";
export const ADD_USER_LANGUAGE = "ADD_USER_LANGUAGE";
export const ADD_USER_SKILLS = "ADD_USER_SKILLS";
export const EDIT_USER_LANGUAGE = "EDIT_USER_LANGUAGE";

const actions = {
  async [FETCH_USER_LANGUAGES]({ commit, dispatch }, userId) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getUserLanguages(userId),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_USER_LANGUAGES, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_USER_LANGUAGES, data)
    });
  },
  async [FETCH_USER_SKILLS]({ commit, dispatch }, userId) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getUserSkills(userId),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_USER_SKILLS, isLoading),
      setDataFunction: ({ data }) => commit(SET_CURRENT_USER_SKILLS, data)
    });
  },
  async [FETCH_ALL_LANGUAGES]({ commit, dispatch }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getAllLanguages(),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_ALL_LANGUAGES, isLoading),
      setDataFunction: ({ data }) => commit(SET_ALL_LANGUAGES, data)
    });
  },
  async [FETCH_ALL_SKILLS]({ commit, dispatch }, params) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getAllSkills(params),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_ALL_SKILLS, isLoading),
      setDataFunction: ({ data }) => commit(SET_ALL_SKILLS, data)
    });
  },
  async [FETCH_LANGUAGE_LEVELS]({ commit, dispatch }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getLanguageLevels(),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_LANGUAGE_LEVELS, isLoading),
      setDataFunction: ({ data }) => commit(SET_LANGUAGE_LEVELS, data)
    });
  },
  async [FETCH_SKILL_LEVELS]({ commit, dispatch }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).getSkillLevels(),
      setLoadingFunction: isLoading =>
        commit(SET_IS_FETCHING_SKILL_LEVELS, isLoading),
      setDataFunction: ({ data }) => commit(SET_SKILL_LEVELS, data)
    });
  },
  async [ADD_USER_LANGUAGE]({ commit, dispatch, state }, { userId, data }) {
    const { data: newLanguage } = await handleWithGlobalMessage(
      () => api(commit).addUserLanguage(userId, data),
      dispatch
    );
    const currentLanguages = state.currentUserLanguages;
    const newLanguages = [...currentLanguages, newLanguage];
    commit(SET_CURRENT_USER_LANGUAGES, newLanguages);
  },
  async [ADD_USER_SKILLS]({ commit, dispatch }, { userId, data }) {
    return handleWithErrorMessage({
      dispatch,
      request: () => api(commit).addUserSkills(userId, data),
      setDataFunction: ({ data }) => commit(SET_CURRENT_USER_SKILLS, data)
    });
  },
  async [EDIT_USER_LANGUAGE](
    { commit, dispatch, state },
    { userId, language }
  ) {
    const { data: updatedLanguage } = await handleWithGlobalMessage(
      () => api(commit).editUserLanguage(userId, language),
      dispatch
    );
    const updatedLanguages = map(state.currentUserLanguages, language => {
      if (language.id !== updatedLanguage.id) return language;
      return updatedLanguage;
    });
    commit(SET_CURRENT_USER_LANGUAGES, updatedLanguages);
  },
  async [REMOVE_USER_LANGUAGE](
    { commit, dispatch, state },
    { languageId, userId }
  ) {
    await handleWithGlobalMessage(
      () => api(commit).removeUserLanguage(languageId, userId),
      dispatch
    );
    const currentLanguages = state.currentUserLanguages;
    const newLanguages = filter(
      currentLanguages,
      ({ id }) => id !== languageId
    );
    commit(SET_CURRENT_USER_LANGUAGES, newLanguages);
  }
};

export default actions;
